
import { defineComponent } from 'vue';
import Form from '@/shared/mixins/Form';
import { required, email, minLength, sameAs } from '@vuelidate/validators';
import { accountService } from './AccountService';
import useVuelidate from '@vuelidate/core';
import config from '@/shared/constants/config';
import PhonePrefix from '@/shared/components/PhonePrefix.vue';
import phoneNumber from '@/shared/helpers/phoneNumberValidator';
import isFacebookApp from '@/shared/helpers/isFacebookApp';
import { googleTagManagerService } from '@/shared/services/GoogleTagManagerService';

export default defineComponent({
  name: 'RegistrationUser',
  mixins: [Form],
  components: {
    PhonePrefix,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      domain: config.DOMAIN,
      privacyUrl: config.PRIVACY_URL,
      generalTermsUrl: config.GENERAL_TERMS_URL,
      form: {
        userName: null,
        email: null,
        phoneNumberPrefix: config.DEFAULT_PHONE_PREFIX,
        phoneNumber: null,
        confirmEmail: null,
        password: null,
        confirmPassword: null,
        generalTermsAgreement: false,
        personalAgreement: false,
        languageId: (window as never)['languageId'],
        externalLoginUrl: config.EXTERNAL_LOGIN_URL,
      },
    };
  },
  computed: {
    externalLoginUrl() {
      return config.EXTERNAL_LOGIN_URL;
    },
    isFacebookApp() {
      return isFacebookApp();
    },
  },
  validations() {
    return {
      form: {
        userName: { required },
        email: { required, email },
        phoneNumberPrefix: {},
        phoneNumber: { phoneNumber: phoneNumber(this.form.phoneNumberPrefix) },
        confirmEmail: { required, sameAsEmail: sameAs(this.form.email) },
        password: { required, minLength: minLength(8) }, // https://jsfiddle.net/sg2zd9mf/
        confirmPassword: { required, sameAsPassword: sameAs(this.form.password) },
        generalTermsAgreement: { sameAs: sameAs(true) },
        personalAgreement: { sameAs: sameAs(true) },
      },
    };
  },
  methods: {
    async register() {
      if (!this.validate()) return;

      try {
        const form = Object.assign({}, this.form);

        if (form.phoneNumberPrefix && form.phoneNumberPrefix.value) {
          form.phoneNumberPrefix = form.phoneNumberPrefix.value;
        }

        await accountService.register(form);
        this.success();
        googleTagManagerService.send({
          event: 'registracia_FO',
        });
      } catch (error) {
        this.handleApiError(error);
      }
    },
  },
});
